<template>
  <div class="tags-wrap">
    <div class="tags-con rela">
      <VuePerfectScrollbar class="scroll-area" @ps-scroll-x="scrollHanle">
        <ul class="scroll-tags">
          <li class="tags-item" :class="{'active':$route.path=='/index'}" :style="styleObject($route.path=='/index')">
            <router-link to="/index">
              系统首页
            </router-link>
          </li>
          <li v-for="(item,index) in tagsList" :key="index" class="tags-item" :class="{'active':$route.path.replace(/\/$/,'')==item.path.replace(/\/$/,'')}" :style="styleObject($route.path.replace(/\/$/,'')==item.path.replace(/\/$/,''))">
            <router-link :to="item.path" :title="item.title">
              {{ item.title }}
            </router-link>
            <span class="cursor" @click="lockNav(index,item.isLock)"><i class="iconfont" :class="item.isLock?'icon-suoding':'icon-jiesuo'"></i></span>
            <span class="tags-close-icon" @click="closeTag(index)" v-if="!item.isLock"><i class="el-icon-close"></i></span>
          </li>
        </ul>
      </VuePerfectScrollbar>
    </div>
    <div class="btn-fullscreen abs mr10" @click="handleFullScreen">
      <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
        <i class="el-icon-rank ft20"></i>
      </el-tooltip>
    </div>
  </div>
</template>

<script>

export default{
  data(){
    return{
      tagsList:[],
      fullscreen:false
    }
  },
  created(){
    var _self = this;
    this.getTags(this.$route)
    // 清除顶部标签栏
    Bus.$on('clearTags',()=>{
      this.tagsList = [];
    })
    Bus.$on('backCloseTags',function(path){
      _self.backCloseTags(path)
    })
  },
  methods:{
    scrollHanle(evt) {
      console.log(evt)
    },
    /**
    *从路由中获取路径显示在顶部标签栏
    **/
    getTags(route){
      const isExist = this.tagsList.some(item => {
        return item.path.replace(/\/$/,'') === route.path.replace(/\/$/,'');
      })

      !isExist && (route.path!='/index') && !route.meta.hideTags && this.tagsList.push({
        title: route.params[route.meta.tagParam] ? route.meta.title + route.params[route.meta.tagParam] : route.meta.title,
        path: route.path,
        isLock:route.meta.isLock
      })
    },
    /**
    *关闭标签
    **/
    closeTag(index){
      const delItem = this.tagsList.splice(index, 1)[0];
      const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
      if (item) {
        delItem.path === this.$route.path && this.$router.push(item.path);
      }else{
        this.$router.push('/');
      }
    },
    backCloseTags(path){
      this.tagsList.map((val,index) => {
        if(val.path == path){
          this.tagsList.splice(index, 1)[0]
        }
      })
    },
    styleObject(isActive){
      if(isActive){
        return 'background-color:#3968fb'//+this.$store.state.themeColor
      }
    },
    lockNav(index,isLock){
        this.$set(this.tagsList[index],'isLock',!isLock)
    },
    addViewTags(to) {
      var isExist = this.$store.state.nocachePage && this.$store.state.nocachePage.some(name => {
        return name == to.name;
      })
      if(!isExist && to.meta.noCache){
        this.$store.commit('getNoCachePages',to.name)
      }
    },
    // 全屏事件
    handleFullScreen(){
      let element = document.documentElement;
      if(this.isFullscreen()) {
        if(document.exitFullscreen) {
          document.exitFullscreen();
        }else if(document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }else if(document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        }else if(document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.fullscreen = false
      }else{
        if(element.requestFullscreen) {
          element.requestFullscreen();
        }else if(element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
        this.fullscreen = true
      }
        // this.fullscreen = !this.fullscreen;
    },
    //判断是否全屏
    isFullscreen(){
      return document.fullscreenElement    ||
            document.msFullscreenElement  ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement || false;
    }
  },
  watch:{
    $route(newValue,oldValue){
      this.getTags(newValue)
      this.addViewTags(newValue)
    }
  }
}
</script>

<style>
.tags-wrap{
  height:40px;
  padding:4px 0 0 15px;
}
.tags-con{
  padding-right: 40px;
}
.tags-wrap .tags-item{
  display: inline-block;
  position: relative;
  height: 26px;
  line-height: 24px;
  border: 1px solid #d8dce5;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 3px;
  border-radius:3px;
  overflow: hidden;
}
.tags-wrap .tags-item.active,.tags-wrap .tags-item.active a{
  color:#fff;
}
.tags-item a{
  color:#000;
  max-width: 100px;
  display:inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  float: left;
}
.tags-close-icon{
  cursor:pointer;
}
.scroll-tags{
  padding-bottom:5px;
  white-space:nowrap;
}
.tags-item .icon-jiesuo{ vertical-align: -1px; }
.btn-fullscreen{
  right: 0;
  top: 10px;
}
</style>
